import SelectionItem from './SelectionItem';
import styles from './SelectionItems.module.css';

export interface SelectItem {
  name: string;
  value: string;
}

export interface SelectionItemsProps {
  type: 'radio' | 'checkbox';
  inputName: string;
  selectItems: SelectItem[];
}

const SelectionItems = ({
  selectItems,
  inputName,
  type,
}: SelectionItemsProps) => {
  const uniqueSelectItems = selectItems.reduce(
    (accumulator: SelectItem[], current) => {
      if (!accumulator.find((item) => item.value === current.value)) {
        accumulator.push(current);
      }
      return accumulator;
    },
    []
  );

  const selectionItems = uniqueSelectItems.map((item, key) => {
    return (
      <SelectionItem
        key={key}
        itemValue={item.value}
        inputName={inputName}
        itemText={item.name}
        type={type}
      />
    );
  });
  return <div className={styles.selectionItemWrapper}>{selectionItems}</div>;
};

export default SelectionItems;
